export default () => {
  const $select = $('.gfield_select');

  $select.on('change', () => {
    const val = $select.val();
    console.log(val);
    // if the value doesn't equal the default value
    if (val !== '') {
      $select.css('color', '#000');
    } else {
      $select.css('color', '#4a4a4a');
    }
    // change font color tp black
  })
};